import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { db_tables, miscellaneous, routes } from '@app/consts';
import { EmployeeService } from '@app/core/services/employee.service';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { finalize } from 'rxjs';
import { TalentTableConfigService, ColumnConfig, FilterConfig, SortConfig } from '@app/core/services/talent-table-config.service';

@Component({
  selector: 'app-employee-filter-string-form-field',
  templateUrl: './employee-filter-string-form-field.component.html',
  styleUrls: ['./employee-filter-string-form-field.component.scss']
})
export class EmployeeFilterStringFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  public gridDataResult: GridDataResult;
  public routes: typeof routes = routes;
  public miscellaneous: typeof miscellaneous = miscellaneous;
  public sort: SortDescriptor[] = [];
  public db_tables = db_tables;
  pageSize: number = 20;
  skip: number = 0;
  isLoading: boolean;
  filter = '(status.id = "Active")';
  filters: {id: string, filterCategory: any, filterOperator: string, filterString: any}[] = [
    {
      "id":"_0nrqezg3p",
      "filterCategory":{
        "field":"status.id",
        "title":"Status",
        "dataType":"ProvidedList",
        "listOptions":{
          "list":[
            {"id":"Active","name":"Active"},
            {"id":"inActive","name":"Inactive"},
            {"id":"Future","name":"Future"}
          ],
          "id":"id",
          "name":"name"
        }
      },
      "filterOperator":"=",
      "filterString":"Active"
    }
  ];
  filterString: string = '(status.id = "Active")';
  searchFilterString: string;
  searchValue: string;
  getEmployeesRequest: any;
  sortString: string = 'Lastname-asc~Firstname-asc';

  public columns: ColumnConfig[] = [];
  public filterCategories: FilterConfig[] = [];
  public sortableColumns: SortConfig[] = [];

  constructor(
    private employeeService: EmployeeService,
    public translate: TranslateService,
    private talentConfigService: TalentTableConfigService
  ) { }

  ngOnInit(): void {
    // Subscribe to configuration changes
    this.talentConfigService.columns$.subscribe(columns => {
      this.columns = columns;
    });

    this.talentConfigService.filters$.subscribe(filters => {
      this.filterCategories = filters;
    });

    this.talentConfigService.sorts$.subscribe(sorts => {
      this.sortableColumns = sorts;
    });

    if (!this.parentGroup.controls[this.formElement.formControl].value) {
      this.parentGroup.controls[this.formElement.formControl].setValue('');
    }
    else {
      this.filters = this.buildFilters(this.parentGroup.controls[this.formElement.formControl].value);
      this.filterString = this.parentGroup.controls[this.formElement.formControl].value;
    }
    this.getEmployees();
  }

  getEmployees(): void {
    this.isLoading = true;

    let filter = '';
    const filters = [];

    if (this.searchFilterString) {
      filters.push(this.searchFilterString);
    }
    if (this.filterString) {
      filters.push(this.filterString);
    }

    filter = filters.join(' AND ');

    this.parentGroup.controls[this.formElement.formControl].setValue(filter);

    this.getEmployeesRequest = this.employeeService.getEmployees2025(this.pageSize, this.skip, filter, this.sortString)
      .pipe(
        finalize(() => { this.isLoading = false; })
      )
      .subscribe(
        res => {
          this.gridDataResult = {
            data: res.data,
            total: res.total,
          }

          this.gridDataResult.data = this.gridDataResult.data.map(emp => {
            emp.employee = {
              id: emp.id,
              firstName: emp.firstName,
              lastName: emp.lastName,
            }
            return emp;
          });
        }
      )
  }

  search(newSearchString: string) {
    this.searchValue = newSearchString;

    let variants = this.searchValue.split(' ').filter(value => value);
    this.searchFilterString = '';
    variants.map(variant => {
      if (variant) {
        if (this.searchFilterString.length > 2) {
          this.searchFilterString += ' AND ';
        }
        this.searchFilterString += `((FirstName like "${variant}") OR (LastName like "${variant}") OR (PreferredName like "${variant}") OR (customClientId like "${variant}"))`;
      }
    });
    this.skip = 0;
    this.getEmployeesRequest.unsubscribe();
    this.getEmployees();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take
    this.getEmployees();
  }

  sortChange(sortString: string) {
    this.sortString = sortString;
    this.getEmployees();
  }

  filterCallback(filterString: string) {
    this.filterString = filterString;
    this.skip = 0;
    this.getEmployees();
  }

  buildFilters(filter: string) {
    let filters = [];

    const filterRegex = /\(([^=!<>]+)(=|!=|<|>|<=|>=)\s*"([^"]*)"\)/g;
    let match;

    while ((match = filterRegex.exec(filter)) !== null) {
      filters.push({
        id: `_${Math.random().toString(36).substr(2, 9)}`,
        filterCategory: {
          field: match[1].trim(),
          title: match[1].trim(),
          dataType: 'Unknown'
        },
        filterOperator: match[2],
        filterString: match[3]
      });
    }

    return filters;
  }
}
